import { createFileRoute } from "@tanstack/react-router";
import AdminModuleEditor from "@/pages/AdminModuleEditor";

export const Route = createFileRoute("/admin/accelerator/modules/")({
  component: AdminModuleEditor,
});
